//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Spinner from 'mint-ui/packages/spinner/index.js';
if (process.env.NODE_ENV === 'component') {
  require('mint-ui/packages/spinner/style.css');
}

export default {
  data() {
    return {
      visible: false
    };
  },

  components: {
    Spinner
  },

  computed: {
    convertedSpinnerType() {
      switch (this.spinnerType) {
        case 'double-bounce':
          return 1;
        case 'triple-bounce':
          return 2;
        case 'fading-circle':
          return 3;
        default:
          return 0;
      }
    }
  },

  props: {
    text: String,
    spinnerType: {
      type: String,
      default: 'snake'
    }
  }
};



// WEBPACK FOOTER //
// ./packages/indicator/src/indicator.vue